var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__a",
    x1: "0%",
    x2: "100%",
    y1: "50.003%",
    y2: "50.003%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__b",
    x1: "0%",
    x2: "100%",
    y1: "49.998%",
    y2: "49.998%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E2E2E2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h23.99v23.34H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    fillRule: "nonzero",
    d: "M22.493 20.664H1.51a1.5 1.5 0 01-1.5-1.499V4.176a1.5 1.5 0 011.5-1.499h20.984a1.5 1.5 0 011.5 1.5v14.988a1.5 1.5 0 01-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D54C3F",
    fillRule: "nonzero",
    d: "M3.008 20.664h-1.5c-.827 0-1.498-.67-1.498-1.499V4.176a1.498 1.498 0 012.248-1.298 1.5 1.5 0 01.75 1.298v16.488z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B63524",
    fillRule: "nonzero",
    d: "M20.994 20.664h1.5c.827 0 1.498-.67 1.498-1.499V4.176a1.499 1.499 0 10-2.998.001v16.487z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE5145",
    fillRule: "nonzero",
    d: "M23.352 5.405a1.5 1.5 0 00-1.717-2.457L12.002 9.96H12L2.367 2.947A1.5 1.5 0 00.65 5.405l-.04-.029L12 13.669m11.392-8.293l-11.391 8.293"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    fillRule: "nonzero",
    d: "M22.493 2.677c-.319 0-.615.1-.858.27l-9.633 7.014H12L2.367 2.947a1.497 1.497 0 00-.858-.27h20.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C64132",
    fillRule: "nonzero",
    d: "M3.008 7.768L.482 5.266l-.001.002c.053.05.11.095.17.137l-.04-.029 2.398 1.746-.001.664"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    fillRule: "nonzero",
    d: "M10.336 14.964l-7.328 5.7V7.705l7.327 7.257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gmail_svg__a)",
    fillRule: "nonzero",
    d: "M10.336 14.964l1.665-1.295-8.993-6.547v.583l7.327 7.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gmail_svg__b)",
    fillRule: "nonzero",
    d: "M16.028 20.664h4.966V7.122l-8.993 6.547-1.666 1.293z"
  }))));
}

export default SvgGmail;